import Loader from './Loader';

export default function LoadingPage() {
  return (
    <div className="fixed top-1/2 left-1/2 -mt-4 -ml-4 h-8 w-8">
      <Loader />
    </div>
  );
}
